export type FetchAdCategoriesResponse = {
  categories: [
    {
      label: string;
      value: string;
      children: [
        {
          label: string;
          value: string;
        }
      ];
    }
  ];
};

export const fetchAdCategories = async () => {
  try {
    const response = await fetch(`/api/proxy/v3/stations/adCategories`, {
      method: 'GET',
      credentials: 'same-origin',
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error('Unable to fetch Ad Categories');
  } catch (err) {
    throw new Error(err.message);
  }
};
